import { api } from '@/lib/api'

export type Plan = {
  id: number
  name: string
  description: string | null
  price: number
  billing_cycle: string
  max_members: number
  max_storage_mb: number
  can_view_financial: boolean
}

export type AgendaSubscription = {
  plan_id: number
  plan_name: string
  is_active: boolean
  is_free: boolean
  started_at: string
  expires_at: string | null
  max_members: number
  max_storage_mb: number
  can_view_financial: boolean
}

export const getAgendaSubscriptionService = (agendaId: string): Promise<AgendaSubscription> =>
  api.get<AgendaSubscription>(`/agendas/${agendaId}/subscription`).then((res) => res.data)

export const getPlansService = (): Promise<Plan[]> =>
  api.get<Plan[]>('/plans').then((res) => res.data)

export type CheckoutPayload = {
  plan_id: number
  customer_name: string
  customer_email: string
  customer_phone: string
  customer_tax_id: string
  customer_postal_code: string
  customer_address: string
  customer_address_number: string
  customer_complement: string
  customer_city: string
  customer_province: string
}

export type CheckoutResponse = {
  checkout_url: string
}

export const checkoutSubscriptionService = (
  agendaId: string,
  payload: CheckoutPayload,
): Promise<CheckoutResponse> =>
  api
    .post<CheckoutResponse>(`/agendas/${agendaId}/subscription/checkout`, payload)
    .then((res) => res.data)
